import type { LawyerCardData } from '@/Types/lawyer';

/**
 * Synthetic fixtures for the design system showcase only. Real lawyer rows
 * arrive via the Phase 7 controllers; do NOT import these from production
 * code paths.
 *
 * Names follow the editorial-trust pattern from the brief: placeholder
 * "Attorney Name" rather than fabricating identities.
 */
export const LAWYER_FIXTURES: LawyerCardData[] = [
    {
        initials: 'AN',
        hue: 0,
        name: 'Attorney Name',
        firm: 'Lakeshore Trial Lawyers',
        city: 'Los Angeles',
        state: 'CA',
        years: 18,
        rating: 4.8,
        reviews: 142,
        areas: ['Car accident', 'Motorcycle', 'Wrongful death', 'Truck'],
        langs: ['EN', 'ES'],
        bio: 'Tries to keep cases out of court — and wins them in court when she can’t. Past trial experience for the Public Defender’s office.',
        phone: '(213) 555-0148',
        responseTime: '32 min',
        contingency: true,
        distance: 1.4,
        featured: true,
    },
    {
        initials: 'BN',
        hue: 60,
        name: 'Attorney Name',
        firm: 'Marquez & Bell, PLLC',
        city: 'Long Beach',
        state: 'CA',
        years: 24,
        rating: 4.7,
        reviews: 206,
        areas: ['Truck', 'Workers’ comp', 'Slip & fall'],
        langs: ['EN', 'ES'],
        bio: 'Two decades of plaintiff-side advocacy with a focus on catastrophic injury. Past board member, Hispanic Bar Association of Los Angeles.',
        phone: '(562) 555-0192',
        responseTime: '45 min',
        contingency: true,
        distance: 4.1,
    },
    {
        initials: 'CN',
        hue: 120,
        name: 'Attorney Name',
        firm: 'Pine Ridge Law',
        city: 'Pasadena',
        state: 'CA',
        years: 11,
        rating: 4.9,
        reviews: 98,
        areas: ['Medical malpractice', 'Wrongful death'],
        langs: ['EN'],
        bio: 'Former hospital-side defense counsel — now uses that perspective on behalf of patients.',
        phone: '(626) 555-0134',
        responseTime: '18 min',
        contingency: true,
        distance: 7.6,
    },
    {
        initials: 'DN',
        hue: 200,
        name: 'Attorney Name',
        firm: 'Harbor & Vine LLP',
        city: 'Santa Monica',
        state: 'CA',
        years: 31,
        rating: 4.6,
        reviews: 312,
        areas: ['Car accident', 'Truck', 'Slip & fall', 'Premises'],
        langs: ['EN'],
        phone: '(310) 555-0167',
        responseTime: '1.1 hr',
        contingency: true,
        distance: 9.2,
    },
];
